import React, { useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Calibration = () => {

  const [size, setSize] = useState({ width: 300, height: 190 });

  const draggingRight = useRef(false);
  const draggingBottom = useRef(false);

  const navigate = useNavigate();
  const location = useLocation();

  const redirectTo = location.state?.redirectTo || "/";

  // 🔥 START DRAG
  const startRight = () => (draggingRight.current = true);
  const startBottom = () => (draggingBottom.current = true);

  const stopDrag = () => {
    draggingRight.current = false;
    draggingBottom.current = false;
  };

  // 🔥 HANDLE MOVE
  const handleMove = (e) => {

    if (!draggingRight.current && !draggingBottom.current) return;

    setSize(prev => {
      let newWidth = prev.width;
      let newHeight = prev.height;

      if (draggingRight.current) {
        newWidth = e.clientX - window.innerWidth / 2 + prev.width / 2;
      }

      if (draggingBottom.current) {
        newHeight = e.clientY - 200; // adjust offset if needed
      }

      return {
        width: Math.max(150, Math.min(newWidth, 600)),
        height: Math.max(80, Math.min(newHeight, 400))
      };
    });
  };

  // 🔥 SAVE
  const saveCalibration = () => {

    const px_per_mm_width = size.width / 85.6;
    const px_per_mm_height = size.height / 54;

    // 🔥 average for better accuracy
    const pixels_in_mm = (px_per_mm_width + px_per_mm_height) / 2;

    localStorage.setItem("pixel_in_mm", pixels_in_mm);

    navigate(redirectTo);
  };

  return (
    <div
      style={{ textAlign: "center", paddingTop: 80 }}
      onMouseMove={handleMove}
      onMouseUp={stopDrag}
    >

      <h2>📏 Screen Calibration</h2>

      <p>
        Match both width & height of your credit card by dragging edges
      </p>

      {/* 🔥 BOX */}
      <div
        style={{
          width: size.width,
          height: size.height,
          background: "#00c853",
          margin: "40px auto",
          borderRadius: 10,
          position: "relative"
        }}
      >

        {/* RIGHT HANDLE */}
        <div
          onMouseDown={startRight}
          style={{
            position: "absolute",
            right: 0,
            top: 0,
            width: 20,
            height: "100%",
            background: "#00000030",
            cursor: "ew-resize"
          }}
        />

        {/* BOTTOM HANDLE */}
        <div
          onMouseDown={startBottom}
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: 20,
            background: "#00000030",
            cursor: "ns-resize"
          }}
        />

      </div>

      <button onClick={saveCalibration}>
        Save & Start 
      </button>

    </div>
  );
};

export default Calibration;